import { BaseClickable, Stack, Text } from '@solvhealth/jigsaw';
import { BaseClickableProps } from '@solvhealth/jigsaw/dist/components/BaseClickable/BaseClickable';
import React from 'react';

const SolvPlusLogo = (props: BaseClickableProps & { height?: string | number }) => {
  return (
    <BaseClickable {...props}>
      <Stack {...props} alignItems="center" row space={0.5}>
        <img height={props.height ?? 24} src="/images/membership/logo_full.svg" />
      </Stack>
    </BaseClickable>
  );
};

export default SolvPlusLogo;
